const JALALI_MONTHS = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
];

const WEEKDAY_LABELS = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'];

function div(a, b) {
  return Math.trunc(a / b);
}

function toISODate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

function gregorianToJalali(gy, gm, gd) {
  const g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  const gy2 = gm > 2 ? gy + 1 : gy;
  let days =
    355666 +
    365 * gy +
    div(gy2 + 3, 4) -
    div(gy2 + 99, 100) +
    div(gy2 + 399, 400) +
    gd +
    g_d_m[gm - 1];
  let jy = -1595 + 33 * div(days, 12053);
  days %= 12053;
  jy += 4 * div(days, 1461);
  days %= 1461;

  if (days > 365) {
    jy += div(days - 1, 365);
    days = (days - 1) % 365;
  }

  const jm = days < 186 ? 1 + div(days, 31) : 7 + div(days - 186, 30);
  const jd = 1 + (days < 186 ? days % 31 : (days - 186) % 30);

  return { year: jy, month: jm, day: jd };
}

function jalaliToGregorian(jy, jm, jd) {
  jy += 1595;
  let days =
    -355668 +
    365 * jy +
    div(jy, 33) * 8 +
    div((jy % 33) + 3, 4) +
    jd +
    (jm < 7 ? (jm - 1) * 31 : (jm - 7) * 30 + 186);
  let gy = 400 * div(days, 146097);
  days %= 146097;

  if (days > 36524) {
    gy += 100 * div(--days, 36524);
    days %= 36524;
    if (days >= 365) {
      days += 1;
    }
  }

  gy += 4 * div(days, 1461);
  days %= 1461;

  if (days > 365) {
    gy += div(days - 1, 365);
    days = (days - 1) % 365;
  }

  let gd = days + 1;
  const monthDays = [
    0,
    31,
    (gy % 4 === 0 && gy % 100 !== 0) || gy % 400 === 0 ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];
  let gm = 1;

  while (gm < 13 && gd > monthDays[gm]) {
    gd -= monthDays[gm];
    gm += 1;
  }

  return { year: gy, month: gm, day: gd };
}

export function normalizeDigits(value) {
  if (value == null) {
    return '';
  }

  return String(value)
    .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - '۰'.charCodeAt(0)))
    .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - '٠'.charCodeAt(0)));
}

export function parseIsoDate(value) {
  if (!value) {
    return null;
  }

  const normalized = normalizeDigits(value);
  const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (!match) {
    return null;
  }

  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3]),
  };
}

export function gregorianIsoToJalali(isoDate) {
  const parsed = parseIsoDate(isoDate);

  if (!parsed) {
    return null;
  }

  return gregorianToJalali(parsed.year, parsed.month, parsed.day);
}

export function jalaliToGregorianIso(year, month, day) {
  const gregorian = jalaliToGregorian(year, month, day);

  return `${gregorian.year}-${String(gregorian.month).padStart(2, '0')}-${String(gregorian.day).padStart(2, '0')}`;
}

export function getJalaliMonthLength(year, month) {
  if (month <= 6) {
    return 31;
  }

  if (month <= 11) {
    return 30;
  }

  const gregorian = jalaliToGregorian(year, 12, 30);
  const jalali = gregorianToJalali(gregorian.year, gregorian.month, gregorian.day);

  return jalali.year === year && jalali.month === 12 && jalali.day === 30 ? 30 : 29;
}

export function getJalaliMonthGrid(year, month) {
  const monthLength = getJalaliMonthLength(year, month);
  const firstIso = jalaliToGregorianIso(year, month, 1);
  const firstWeekday = new Date(`${firstIso}T00:00:00`).getDay();
  const startOffset = (firstWeekday + 1) % 7;
  const cells = [];

  for (let index = 0; index < 42; index += 1) {
    const dayNumber = index - startOffset + 1;

    if (dayNumber < 1 || dayNumber > monthLength) {
      cells.push(null);
    } else {
      cells.push({
        day: dayNumber,
        iso: jalaliToGregorianIso(year, month, dayNumber),
      });
    }
  }

  return cells;
}

export function shiftJalaliMonth(year, month, delta) {
  const next = month + delta;
  const wrappedMonth = ((next - 1) % 12 + 12) % 12 + 1;
  const wrappedYear = year + Math.floor((next - 1) / 12);

  return { year: wrappedYear, month: wrappedMonth };
}

export function getDefaultDateRange(days = 30) {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(endDate.getDate() - days + 1);

  return {
    startDate: toISODate(startDate),
    endDate: toISODate(endDate),
  };
}

export function formatJalaliDate(value) {
  if (!value) {
    return 'بدون تاریخ';
  }

  const normalized = normalizeDigits(value);
  const date = /^\d{4}-\d{2}-\d{2}$/.test(normalized)
    ? new Date(`${normalized}T00:00:00`)
    : new Date(normalized);

  if (Number.isNaN(date.getTime())) {
    return 'بدون تاریخ';
  }

  return new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

export function formatJalaliInputValue(value) {
  if (!value) {
    return '';
  }

  const jalali = gregorianIsoToJalali(value);

  if (!jalali) {
    return '';
  }

  return new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(`${value}T00:00:00`));
}

export function formatDateRangeLabel(startDate, endDate) {
  if (!startDate && !endDate) {
    return 'همه تاریخ‌ها';
  }

  if (startDate && endDate) {
    return `از ${formatJalaliDate(startDate)} تا ${formatJalaliDate(endDate)}`;
  }

  if (startDate) {
    return `از ${formatJalaliDate(startDate)}`;
  }

  return `تا ${formatJalaliDate(endDate)}`;
}

export function getTodayJalali() {
  return gregorianIsoToJalali(toISODate(new Date()));
}

export { JALALI_MONTHS, WEEKDAY_LABELS };
